/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextbold2Inputs */

const en_richtextbold2 = /** @type {(inputs: Richtextbold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold`)
};

const de_richtextbold2 = /** @type {(inputs: Richtextbold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fett`)
};

/**
* | output |
* | --- |
* | "Bold" |
*
* @param {Richtextbold2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextbold2 = /** @type {((inputs?: Richtextbold2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextbold2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextbold2(inputs)
	return de_richtextbold2(inputs)
});
export { richtextbold2 as "richTextBold" }